import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/project/ClerkScreen';
import { ButtonText } from './Styles';

const DecisionButtonText = ({ confirming, text }) => (
  <ButtonText>
    <Icon icon="gavel" size={1.5} />
    {confirming ? `Confirm ${text}` : text}
  </ButtonText>
);

DecisionButtonText.defaultProps = {
  confirming: false,
};

DecisionButtonText.propTypes = {
  confirming: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

export default React.memo(DecisionButtonText);
